import { unifiedControlStyle } from "../../../components/ReusableDropdown";

// Function to get dynamic responsive styles based on theme and screen size
export const getResponsiveStyles = ({ theme, screenSize, spacing, fonts, language }) => ({
  // ===== RESPONSIVE HEADER CONTAINER =====
  header: {
    background:
      theme === "light"
        ? "rgba(255, 255, 255, 0.9)"
        : "rgba(255, 255, 255, 0.08)",
    border:
      theme === "light"
        ? "1px solid rgba(0, 0, 0, 0.1)"
        : "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius:
      screenSize === "xs"
        ? "1rem"
        : screenSize === "sm"
          ? "1.25rem"
          : "1.5rem",
    padding: spacing.padding,
    marginBottom: spacing.margin,
    backdropFilter: "blur(0px)",
    boxShadow:
      theme === "light"
        ? "0 1.25rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.1)"
        : "0 1.25rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.5)",
    transition: "all 0.3s ease",
  },

  // ===== RESPONSIVE SECONDARY HEADER =====
  header2: {
    background:
      theme === "light"
        ? "rgba(255, 255, 255, 0.9)"
        : "rgba(255, 255, 255, 0.08)",
    border:
      theme === "light"
        ? "1px solid rgba(0, 0, 0, 0.1)"
        : "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius:
      screenSize === "xs"
        ? "1rem"
        : screenSize === "sm"
          ? "1.25rem"
          : "1.5rem",
    padding: spacing.padding,
    height: screenSize === "xs" ? "auto" : "3.125rem",
    marginBottom: spacing.margin,
    backdropFilter: "blur(0px)",
    boxShadow:
      theme === "light"
        ? "0 1.25rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.1)"
        : "0 1.25rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.5)",
    transition: "all 0.3s ease",
  },

  // ===== RESPONSIVE MAIN CONTAINER =====
  container: {
    direction: language === "ar" ? "rtl" : "ltr", // ✅ أضف هذا السطر
  },

  // ===== RESPONSIVE ALERT NOTIFICATION =====
  alert: {
    marginTop: "5%",
    position: "fixed",
    top: screenSize === "xs" ? "0.5rem" : "1.25rem",
    right: screenSize === "xs" ? "0.5rem" : "1.25rem",
    zIndex: 3000,
    display: "flex",
    alignItems: "center",
    gap: screenSize === "xs" ? "0.5rem" : "0.75rem",
    padding: screenSize === "xs" ? "0.75rem 1rem" : "0.75rem 1rem",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.5rem",
    border: "1px solid",
    maxWidth: screenSize === "xs" ? "calc(100vw - 1rem)" : "25rem",
    backdropFilter: "blur(0.625rem)",
    animation: "slideIn 0.3s ease-out",
  },

  // ===== ALERT CLOSE BUTTON =====
  alertClose: {
    background: "none",
    border: "none",
    color: "inherit",
    cursor: "pointer",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginLeft: "auto",
  },

  // ===== RESPONSIVE WELCOME SECTION =====
  welcomeSection: {
    marginBottom: screenSize === "xs" ? "1rem" : "1rem",
  },

  // ===== RESPONSIVE WELCOME TITLE =====
  welcomeTitle: {
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: "28px",
    fontWeight: "700",
    margin: `0 0 ${screenSize === "xs" ? "0.5rem" : "0.5rem"} 0`,
    textShadow:
      theme === "dark"
        ? "0 0.125rem 0.25rem rgba(0,0,0,0.3)"
        : "0 0.125rem 0.25rem rgba(0,0,0,0.1)",
    lineHeight: "1.2",
    marginBottom: 25,
  },
  selectOption: {
    background: theme === "dark" ? "rgba(30, 41, 59, 0.9)" : "rgba(255, 255, 255, 0.9)",
    color: theme === "dark" ? "#f8fafc" : "#0f172a",
    padding: "clamp(10px, 1.5vw, 14px) 18px",
    fontWeight: 600,
    fontSize: "clamp(14px, 1.2vw, 16px)",
    borderRadius: "clamp(10px, 1.5vw, 14px)",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.1)",
    boxShadow: theme === "dark"
      ? "0 4px 15px rgba(0,0,0,0.5)"
      : "0 4px 15px rgba(0,0,0,0.1)",
    outline: "none",
    cursor: "pointer",
    transition: "all 0.25s ease-in-out",
    marginBottom: "30px",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  },

  // ===== RESPONSIVE WELCOME SUBTITLE =====
  welcomeSubtitle: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
    fontSize: fonts.subtitle,
    margin: 0,
    textShadow:
      theme === "dark"
        ? "0 0.0625rem 0.125rem rgba(0,0,0,0.3)"
        : "0 0.0625rem 0.125rem rgba(0,0,0,0.1)",
    lineHeight: "1.4",
  },

  // ===== RESPONSIVE TOP BUTTONS CONTAINER =====
  topButtonsContainer: {
    display: "flex",
    gap: spacing.gap,
    marginBottom: spacing.margin,
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: screenSize === "xs" ? "center" : "flex-start",
  },

  // ===== RESPONSIVE PRIMARY BUTTON =====
  primaryBtn: {
    background: "#2e7cba",
    color: "white",
    border: "none",
    padding: screenSize === "xs" ? "0.75rem 1rem" : "0.75rem 1.25rem",
    borderRadius: screenSize === "xs" ? "0.625rem" : "0.625rem",
    cursor: "pointer",
    fontSize: fonts.body,
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: screenSize === "xs" ? "0.5rem" : "0.5rem",
    transition: "all 0.2s",
    whiteSpace: "nowrap",
  },

  // ===== RESPONSIVE SECONDARY BUTTON =====
  secondaryBtn: {
    background:
      theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
    color: theme === "dark" ? "white" : "#1a1a1a",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.2)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    padding: screenSize === "xs" ? "0.75rem 1rem" : "0.75rem 1.25rem",
    borderRadius: screenSize === "xs" ? "0.625rem" : "0.625rem",
    cursor: "pointer",
    fontSize: fonts.body,
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: screenSize === "xs" ? "0.5rem" : "0.5rem",
    transition: "all 0.2s",
    whiteSpace: "nowrap",
  },

  // ===== RESPONSIVE STATISTICS CARD =====
  statCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
    padding: "1.55rem",
    //marginTop: -50,
    marginLeft: 5,
    borderRadius:
      screenSize === "xs" ? "1rem" : screenSize === "sm" ? "1.25rem" : "1rem",
    transition: "all 0.3s ease",
    boxShadow:
      theme === "dark"
        ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
        : "0 0.5rem 2rem rgba(0,0,0,0.1)",
    backdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
    WebkitBackdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.05)",
    marginBottom: 10,
    cursor: "pointer",
  },

  // ===== RESPONSIVE GENERAL CARD =====
  card: {
    background:
      theme === "dark"
        ? "rgba(255, 255, 255, 0.08)"
        : "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(1.5625rem)",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.05)",
    borderRadius: screenSize === "xs" ? "1rem" : "1.25rem",
    padding: spacing.padding,
    boxShadow:
      theme === "dark"
        ? "0 0.5rem 2rem rgba(0, 0, 0, 0.2)"
        : "0 0.5rem 2rem rgba(0, 0, 0, 0.1)",
    marginBottom: spacing.margin,
    transition: "all 0.3s ease",
    cursor: "pointer",
  },

  // ===== RESPONSIVE CARD TITLE =====
  cardTitle: {
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: fonts.subtitle,
    fontWeight: "600",
    margin: `0 0 ${spacing.margin} 0`,
    textShadow:
      theme === "dark"
        ? "0 0.0625rem 0.125rem rgba(0,0,0,0.3)"
        : "0 0.0625rem 0.125rem rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    gap: screenSize === "xs" ? "0.5rem" : "0.5rem",
    flexWrap: screenSize === "xs" ? "wrap" : "nowrap",
  },

  // ===== RESPONSIVE FILTER CONTAINER =====
  filterContainer: {
    display: "grid",
    gridTemplateColumns:
      screenSize === "xs"
        ? "1fr"
        : screenSize === "sm"
          ? "repeat(2, 1fr)"
          : screenSize === "md"
            ? "repeat(3, 1fr)"
            : "repeat(4, 1fr)",
    gap: spacing.gap,
    marginBottom: spacing.margin,
  },

  // ===== FILTER GROUP =====
  filterGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "0.375rem",
  },

  // ===== RESPONSIVE FILTER LABEL =====
  filterLabel: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
    fontSize: fonts.small,
    fontWeight: "500",
    marginBottom: "0.25rem",
  },

  // ===== RESPONSIVE FILTER INPUT =====
  filterInput: {
    // Use unified control style so inputs and dropdowns match visually
    ...unifiedControlStyle(theme, language === "ar"),
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.5rem",
    padding: screenSize === "xs" ? "0.625rem 0.75rem" : "0.625rem 0.75rem",
    fontSize: fonts.body,
    transition: "border-color 0.2s",
    width: "100%",
  },

  // ===== RESPONSIVE TABLE CONTAINER =====
  tableContainer: {
    overflowX: "auto",
    overflowY: "hidden",
    marginTop: spacing.margin,
    borderRadius: screenSize === "xs" ? "0.75rem" : "1rem",
    position: "relative",
    // Add horizontal scroll for mobile
    ...(screenSize === "xs" && {
      maxWidth: "100%",
      WebkitOverflowScrolling: "touch",
    }),
  },

  // ===== RESPONSIVE TABLE WRAPPER =====
  tableWrapper: {
    position: "relative",
    borderRadius: screenSize === "xs" ? "0.75rem" : "1rem",
    overflowY: "hidden",
  },

  // ===== RESPONSIVE TABLE =====
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    minWidth:
      screenSize === "xs" ? "600px" : screenSize === "sm" ? "700px" : "900px",
    position: "relative",
    zIndex: 1,
  },

  // ===== RESPONSIVE TABLE HEADER =====
  tableHeader: {
    background:
      theme === "dark"
        ? "linear-gradient(135deg, rgba(55, 65, 81, 0.8), rgba(75, 85, 99, 0.8))"
        : "linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(241, 245, 249, 0.95))",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    padding:
      screenSize === "xs"
        ? "0.75rem 0.5rem"
        : screenSize === "sm"
          ? "1rem 0.75rem"
          : "1.25rem 1rem",
    textAlign: "left",
    fontSize: fonts.tiny,
    fontWeight: "700",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    borderBottom:
      theme === "dark"
        ? "2px solid rgba(59, 130, 246, 0.3)"
        : "2px solid rgba(59, 130, 246, 0.1)",
    whiteSpace: screenSize === "xs" ? "nowrap" : "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backdropFilter: "blur(0.625rem)",
    boxShadow:
      theme === "dark"
        ? "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.3)"
        : "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },

  // ===== RESPONSIVE TABLE CELL =====
  tableCell: {
    padding:
      screenSize === "xs"
        ? "0.75rem 0.5rem"
        : screenSize === "sm"
          ? "1rem 0.75rem"
          : "1.25rem 1rem",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.06)"
        : "1px solid rgba(148, 163, 184, 0.08)",
    color:
      theme === "dark"
        ? "rgba(248, 250, 252, 0.95)"
        : "rgba(30, 41, 59, 0.9)",
    fontSize: fonts.body,
    fontWeight: "500",
    verticalAlign: "middle",
    position: "relative",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    background: "transparent",
  },

  // ===== RESPONSIVE TABLE ROW =====
  tableRow: {
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    position: "relative",
  },

  // ===== RESPONSIVE USER AVATAR =====
  userAvatar: {
    width:
      screenSize === "xs"
        ? "2rem"
        : screenSize === "sm"
          ? "2.25rem"
          : "2.5rem",
    height:
      screenSize === "xs"
        ? "2rem"
        : screenSize === "sm"
          ? "2.25rem"
          : "2.5rem",
    borderRadius: "150%",
    background: "linear-gradient(135deg, #2e7cba 0%, #22354d 100%)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize:
      screenSize === "xs"
        ? "0.75rem"
        : screenSize === "sm"
          ? "0.875rem"
          : "1rem",
    fontWeight: "700",
    position: "relative",
    border: "0.7px solid rgba(255, 255, 255, 0.2)",
    boxShadow:
      theme === "dark"
        ? "0 0.5rem 1rem rgba(0, 0, 0, 0.4)"
        : "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
    transition: "all 0.3s ease",
    flexShrink: 0,
  },

  // ===== RESPONSIVE ACTION BUTTON =====
  actionBtn: {
    background: "rgba(59, 130, 246, 0.1)",
    color: "#2e7cba",
    border: "1px solid rgba(59, 130, 246, 0.2)",
    padding: screenSize === "xs" ? "0.375rem 0.5rem" : "0.5rem 0.75rem",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.5rem",
    cursor: "pointer",
    fontSize: fonts.small,
    fontWeight: "500",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: screenSize === "xs" ? "2rem" : "2.25rem",
    height: screenSize === "xs" ? "2rem" : "2.25rem",
  },

  // ===== SPECIFIC ACTION BUTTON STYLES =====
  viewBtn: {
    background: "rgba(16, 185, 129, 0.1)",
    color: "#10b981",
    border: "1px solid rgba(16, 185, 129, 0.2)",
  },

  editBtn: {
    background: "rgba(245, 158, 11, 0.1)",
    color: "#f59e0b",
    border: "1px solid rgba(245, 158, 11, 0.2)",
  },

  deleteBtn: {
    background: "rgba(239, 68, 68, 0.1)",
    color: "#ef4444",
    border: "1px solid rgba(239, 68, 68, 0.2)",
  },

  archiveBtn: {
    background: "rgba(107, 114, 128, 0.1)",
    color: "#6b7280",
    border: "1px solid rgba(107, 114, 128, 0.2)",
  },

  SendBtn: {
    background: "rgba(107, 114, 128, 0.1)",
    color: "#0055ffff",
    border: "1px solid rgba(107, 114, 128, 0.2)",
  },

  restoreBtn: {
    background: "rgba(34, 197, 94, 0.1)",
    color: "#22c55e",
    border: "1px solid rgba(34, 197, 94, 0.2)",
  },

  // ===== RESPONSIVE TOGGLE BUTTON =====
  toggleBtn: {
    background:
      theme === "dark"
        ? "rgba(59, 130, 246, 0.15)"
        : "rgba(59, 130, 246, 0.1)",
    border:
      theme === "dark"
        ? "1px solid rgba(59, 130, 246, 0.4)"
        : "1px solid rgba(59, 130, 246, 0.3)",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.5rem",
    padding: screenSize === "xs" ? "0.5rem 0.75rem" : "0.5rem 1rem",
    cursor: "pointer",
    color: theme === "dark" ? "#d1d5db" : "#374151",
    fontWeight: "500",
    fontSize: fonts.body,
    display: "inline-flex",
    alignItems: "center",
    gap: "0.375rem",
    transition: "all 0.2s ease",
  },

  // ===== RESPONSIVE MODAL =====
  modal: {
    position: "fixed",
    top: screenSize === "xs" ? 0 : -80,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: screenSize === "xs" ? "flex-start" : "flex-start",
    justifyContent: "center",
    zIndex: 2000,
    padding: screenSize === "xs" ? "0" : "0",
    overflowY: "scroll", // مهم
    backdropFilter: "blur(10px)",
    WebkitOverflowScrolling: "touch", // للـ iOS
    scrollbarWidth: "none", // للـ Firefox
    msOverflowStyle: "none", // للـ IE و Edge
  },
  // ===== RESPONSIVE MODAL CONTENT =====
  modalContent: {
    background:
      theme === "dark"
        ? "rgba(15, 23, 42, 0.95)"
        : "rgba(255, 255, 255, 0.95)",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: screenSize === "xs" ? "1rem" : "1.25rem",
    padding: screenSize === "xs" ? "1.5rem" : "2rem",
    width: screenSize === "xs" ? "100%" : "90%",
    maxWidth:
      screenSize === "xs"
        ? "100%"
        : screenSize === "sm"
          ? "35rem"
          : "43.75rem",
    margin: screenSize === "xs" ? "0" : "11.875rem auto",
    maxHeight: screenSize === "xs" ? "100vh" : "80vh",
    overflowY: "scroll", // مهم
    backdropFilter: "blur(10px)",
    WebkitOverflowScrolling: "touch", // للـ iOS
    scrollbarWidth: "none", // للـ Firefox
    msOverflowStyle: "none", // للـ IE و Edge
  },

  modalContent1: {
    background:
      theme === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(255, 255, 255, 0.95)",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: screenSize === "xs" ? "1rem" : "1.25rem",
    padding: screenSize === "xs" ? "1.5rem" : "2rem",
    width: screenSize === "xs" ? "100%" : "90%",
    maxWidth:
      screenSize === "xs"
        ? "100%"
        : screenSize === "sm"
          ? "50rem"
          : "93.75rem",
    margin: screenSize === "xs" ? "0" : "11.875rem auto",
    maxHeight: screenSize === "xs" ? "100vh" : "80vh",
    overflowY: "auto",
    backdropFilter: "blur(10px)",
    WebkitOverflowScrolling: "touch", // للـ iOS
    scrollbarWidth: "none", // للـ Firefox
    msOverflowStyle: "none", // للـ IE و Edge
  },

  // ===== RESPONSIVE VIEW MODAL CONTENT =====
  viewModalContent: {
    background:
      theme === "dark"
        ? "rgba(15, 23, 42, 0.95)"
        : "rgba(255, 255, 255, 0.95)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.12)"
        : "1px solid rgba(0,0,0,0.08)",
    borderRadius: screenSize === "xs" ? "1rem" : "1.25rem",
    padding: screenSize === "xs" ? "1.5rem" : "2rem",
    width: screenSize === "xs" ? "100%" : "90%",
    maxWidth: screenSize === "xs" ? "100%" : "50%",
    maxHeight: screenSize === "xs" ? "100vh" : "80vh",
    marginTop: screenSize === "xs" ? "0" : "10%",
    marginBottom: screenSize === "xs" ? "0" : "5%",
    overflowY: "scroll", // مهم
    backdropFilter: "blur(10px)",
    WebkitOverflowScrolling: "touch", // للـ iOS
    scrollbarWidth: "none", // للـ Firefox
    msOverflowStyle: "none", // للـ IE و Edge
  },

  // ===== VIEW MODAL BODY =====
  viewModalBody: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.margin,
  },

  // ===== RESPONSIVE EMPLOYEE HEADER =====
  employeeHeader: {
    display: "flex",
    alignItems: "center",
    gap: spacing.margin,
    padding: spacing.padding,
    background:
      theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)",
    borderRadius: screenSize === "xs" ? "0.75rem" : "1rem",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.05)",
    flexDirection: screenSize === "xs" ? "column" : "row",
    textAlign: screenSize === "xs" ? "center" : "left",
  },

  // ===== RESPONSIVE LARGE AVATAR =====
  largeAvatar: {
    width: screenSize === "xs" ? "4rem" : "5rem",
    height: screenSize === "xs" ? "4rem" : "5rem",
    borderRadius: "50%",
    fontSize: screenSize === "xs" ? "1.5rem" : "1.75rem",
    background: "#2e7cba",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: "700",
    boxShadow: "0 0.25rem 0.75rem rgba(0,0,0,0.3)",
    flexShrink: 0,
  },

  // ===== EMPLOYEE HEADER INFO =====
  employeeHeaderInfo: {
    flex: 1,
  },

  // ===== RESPONSIVE EMPLOYEE NAME =====
  employeeName: {
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: screenSize === "xs" ? "1.5rem" : "1.75rem",
    fontWeight: "700",
    margin: `0 0 ${screenSize === "xs" ? "0.5rem" : "0.5rem"} 0`,
  },

  // ===== RESPONSIVE EMPLOYEE TITLE =====
  employeeTitle: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
    fontSize: fonts.subtitle,
    fontWeight: "500",
    margin: "0 0 0.25rem 0",
  },

  // ===== RESPONSIVE EMPLOYEE DEPARTMENT =====
  employeeDepartment: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(26, 26, 26, 0.6)",
    fontSize: fonts.body,
    margin: "0 0 0.75rem 0",
  },

  // ===== EMPLOYEE STATUS =====
  employeeStatus: {
    display: "inline-block",
  },

  // ===== RESPONSIVE INFORMATION SECTION =====
  infoSection: {
    background:
      theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.02)",
    borderRadius: screenSize === "xs" ? "0.75rem" : "1rem",
    padding: spacing.padding,
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.05)",
  },

  // ===== RESPONSIVE SECTION HEADER =====
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: screenSize === "xs" ? "0.5rem" : "0.75rem",
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: fonts.subtitle,
    fontWeight: "600",
    marginBottom: spacing.margin,
    paddingBottom: screenSize === "xs" ? "0.5rem" : "0.75rem",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
  },

  // ===== RESPONSIVE INFORMATION GRID =====
  infoGrid: {
    display: "grid",
    gridTemplateColumns:
      screenSize === "xs"
        ? "1fr"
        : screenSize === "sm"
          ? "1fr"
          : "repeat(auto-fit, minmax(18.75rem, 1fr))",
    gap: spacing.margin,
  },

  // ===== RESPONSIVE INFO ITEM =====
  infoItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: screenSize === "xs" ? "0.5rem" : "0.75rem",
    padding: screenSize === "xs" ? "0.75rem" : "1rem",
    background:
      theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.02)",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.75rem",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.05)"
        : "1px solid rgba(0, 0, 0, 0.03)",
  },

  // ===== INFO LABEL =====
  infoLabel: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(26, 26, 26, 0.6)",
    fontSize: fonts.tiny,
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.03125rem",
    marginBottom: "0.25rem",
  },

  // ===== INFO VALUE =====
  infoValue: {
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: fonts.body,
    fontWeight: "500",
    lineHeight: "1.4",
  },

  // ===== RESPONSIVE MODAL HEADER =====
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: screenSize === "xs" ? "1.5rem" : "2rem",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    paddingBottom: screenSize === "xs" ? "0.75rem" : "1rem",
    flexWrap: screenSize === "xs" ? "wrap" : "nowrap",
    gap: screenSize === "xs" ? "1rem" : "0",
    overflowY: "scroll", // مهم
    scrollbarWidth: "none", // Firefox
  },

  // ===== RESPONSIVE MODAL TITLE =====
  modalTitle: {
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: screenSize === "xs" ? "1.25rem" : "1.5rem",
    fontWeight: "700",
    margin: 0,
  },

  // ===== CLOSE BUTTON =====
  closeBtn: {
    background: "none",
    border: "none",
    color: theme === "dark" ? "white" : "#1a1a1a",
    cursor: "pointer",
    padding: "0.5rem",
    borderRadius: "0.5rem",
    transition: "background 0.2s",
  },

  // ===== RESPONSIVE SECTION TITLE =====
  sectionTitle: {
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.9)" : "rgba(26, 26, 26, 0.8)",
    fontSize: fonts.subtitle,
    fontWeight: "600",
    margin: `${spacing.margin} 0 ${screenSize === "xs" ? "0.75rem" : "1rem"
      } 0`,
    paddingBottom: "0.5rem",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
  },

  // ===== FORM GROUP =====
  formGroup: {
    marginBottom: spacing.margin,
  },

  // ===== RESPONSIVE FORM LABEL =====
  formLabel: {
    display: "block",
    color:
      theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
    fontSize: fonts.body,
    fontWeight: "500",
    marginBottom: "0.5rem",
  },

  // ===== RESPONSIVE FORM INPUT =====
  formInput: {
    background:
      theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.2)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.5rem",
    padding: screenSize === "xs" ? "0.75rem" : "0.75rem",
    color: theme === "dark" ? "white" : "#1a1a1a",
    fontSize: fonts.body,
    outline: "none",
    width: "100%",
    transition: "border-color 0.2s",
    boxSizing: "border-box",
  },
  formSelectOption: {
    background: theme === "dark" ? "#333" : "#fff",
    color: theme === "dark" ? "#fff" : "#000",
  },

  // ===== RESPONSIVE FORM SELECT =====
  formSelect: {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",

    background:
      theme === "dark"
        ? "  rgba(255, 255, 255, 0.1)"
        : "rgba(45, 39, 39, 0.2)",

    color: theme === "dark" ? "#f1f5f9" : "#1e293b",

    border:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.2)"
        : "1px solid rgba(0, 0, 0, 0.15)",

    borderRadius: "0.625rem",
    padding: "0.7rem ",
    fontSize: fonts.body,
    fontWeight: "500",
    width: "100%",
    outline: "none",
    cursor: "pointer",
    backgroundRepeat: "no-repeat",
  },

  // ===== RESPONSIVE FORM ROW =====
  formRow: {
    display: "grid",
    gridTemplateColumns: screenSize === "xs" ? "1fr" : "1fr 1fr",
    gap: spacing.gap,
  },

  // ===== RESPONSIVE MODAL ACTIONS =====
  modalActions: {
    display: "flex",
    gap: screenSize === "xs" ? "0.75rem" : "0.75rem",
    justifyContent: screenSize === "xs" ? "center" : "flex-end",
    marginTop: screenSize === "xs" ? "1.5rem" : "2rem",
    paddingTop: spacing.padding,
    borderTop:
      theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.1)",
    flexWrap: screenSize === "xs" ? "wrap" : "nowrap",
  },

  // ===== ERROR TEXT =====
  errorText: {
    color: "#ef4444",
    fontSize: fonts.small,
    marginTop: "0.25rem",
    display: "block",
  },
});

// ===== RESPONSIVE HOVER EFFECTS =====
export const getPrimaryBtnHoverStyles = (screenSize) => ({
  transform: screenSize === "xs" ? "translateY(-1px)" : "translateY(-2px)",
  boxShadow:
    screenSize === "xs"
      ? "0 0.25rem 0.75rem rgba(59, 130, 246, 0.3)"
      : "0 0.375rem 1.25rem rgba(59, 130, 246, 0.4)",
});

export const getPrimaryBtnDefaultStyles = () => ({
  transform: "translateY(0)",
  boxShadow: "none",
});

export const getSecondaryBtnHoverStyles = (hoverColor = "#10b981") => ({
  background: `rgba(${hoverColor === "#10b981"
    ? "16, 185, 129"
    : hoverColor === "#f59e0b"
      ? "245, 158, 11"
      : "255, 255, 255"
    }, 0.2)`,
  borderColor: hoverColor,
  color: hoverColor,
});

export const getSecondaryBtnDefaultStyles = (theme) => ({
  background:
    theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
  borderColor:
    theme === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.1)",
  color: theme === "dark" ? "white" : "#1a1a1a",
});

export const getCloseBtnHoverStyles = (theme) => ({
  background:
    theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
});

export const getCloseBtnDefaultStyles = () => ({
  background: "none",
});

export const getCardHoverStyles = (theme, screenSize) => ({
  transform: screenSize === "xs" ? "translateY(-1px)" : "translateY(-2px)",
  boxShadow:
    theme === "dark"
      ? screenSize === "xs"
        ? "0 0.5rem 1.5rem rgba(0, 0, 0, 0.3)"
        : "0 0.75rem 2.5rem rgba(0, 0, 0, 0.3)"
      : screenSize === "xs"
        ? "0 0.5rem 1.5rem rgba(0, 0, 0, 0.15)"
        : "0 0.75rem 2.5rem rgba(0, 0, 0, 0.15)",
});

export const getCardDefaultStyles = (theme) => ({
  transform: "translateY(0)",
  boxShadow:
    theme === "dark"
      ? "0 0.5rem 2rem rgba(0, 0, 0, 0.2)"
      : "0 0.5rem 2rem rgba(0, 0, 0, 0.1)",
});

// Get hover styles for stat cards
export const getStatCardHoverStyles = (theme, screenSize) => ({
  transform: screenSize === "xs" ? "translateY(-2px)" : "translateY(-5px)",
  boxShadow:
    theme === "dark"
      ? screenSize === "xs"
        ? "0 0.5rem 1.5rem rgba(0,0,0,0.4), inset 0 0.0625rem 0 rgba(255,255,255,0.2)"
        : "0 0.75rem 2.5rem rgba(0,0,0,0.4), inset 0 0.0625rem 0 rgba(255,255,255,0.2)"
      : screenSize === "xs"
        ? "0 0.5rem 1.5rem rgba(0,0,0,0.15)"
        : "0 0.75rem 2.5rem rgba(0,0,0,0.15)",
  background:
    theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.95)",
  border:
    theme === "dark"
      ? "1px solid rgba(255,255,255,0.2)"
      : "1px solid rgba(0,0,0,0.05)",
  backdropFilter:
    theme === "dark" ? "blur(1.875rem) saturate(200%)" : "blur(0.9375rem)",
  WebkitBackdropFilter:
    theme === "dark" ? "blur(1.875rem) saturate(200%)" : "blur(0.9375rem)",
});

// Default styles for stat cards when not hovered
export const getStatCardDefaultStyles = (theme) => ({
  transform: "translateY(0)",
  boxShadow:
    theme === "dark"
      ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
      : "0 0.5rem 2rem rgba(0,0,0,0.1)",
  background:
    theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
  border:
    theme === "dark"
      ? "1px solid rgba(255,255,255,0.15)"
      : "1px solid rgba(0,0,0,0.05)",
  backdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
  WebkitBackdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
});

// ===== EVENT HANDLERS FOR HOVER EFFECTS =====
// Recreated each render with the current theme/screenSize/loading values,
// exactly like the original inline handlers.
export const createHoverHandlers = ({ theme, screenSize, loading }) => ({
  handlePrimaryBtnMouseEnter: (e) => {
    if (!loading) {
      const hoverStyles = getPrimaryBtnHoverStyles(screenSize);
      Object.assign(e.currentTarget.style, hoverStyles);
    }
  },

  handlePrimaryBtnMouseLeave: (e) => {
    if (!loading) {
      const defaultStyles = getPrimaryBtnDefaultStyles();
      Object.assign(e.currentTarget.style, defaultStyles);
    }
  },

  handleSecondaryBtnMouseEnter: (e, hoverColor = "#10b981") => {
    if (!loading) {
      const hoverStyles = getSecondaryBtnHoverStyles(hoverColor);
      Object.assign(e.currentTarget.style, hoverStyles);
    }
  },

  handleSecondaryBtnMouseLeave: (e) => {
    if (!loading) {
      const defaultStyles = getSecondaryBtnDefaultStyles(theme);
      Object.assign(e.currentTarget.style, defaultStyles);
    }
  },

  handleCloseBtnMouseEnter: (e) => {
    const hoverStyles = getCloseBtnHoverStyles(theme);
    Object.assign(e.currentTarget.style, hoverStyles);
  },

  handleCloseBtnMouseLeave: (e) => {
    const defaultStyles = getCloseBtnDefaultStyles();
    Object.assign(e.currentTarget.style, defaultStyles);
  },

  handleCardMouseEnter: (e) => {
    const hoverStyles = getCardHoverStyles(theme, screenSize);
    Object.assign(e.currentTarget.style, hoverStyles);
  },

  handleCardMouseLeave: (e) => {
    const defaultStyles = getCardDefaultStyles(theme);
    Object.assign(e.currentTarget.style, defaultStyles);
  },

  // Action button hover effects
  handleActionBtnMouseEnter: (e, type) => {
    const hoverStyles = {
      transform:
        screenSize === "xs" ? "translateY(-0.5px)" : "translateY(-1px)",
      boxShadow:
        screenSize === "xs"
          ? "0 0.25rem 0.5rem rgba(0,0,0,0.1)"
          : "0 0.25rem 0.75rem rgba(0,0,0,0.15)",
    };

    if (type === "view") {
      hoverStyles.background = "rgba(16, 185, 129, 0.2)";
    } else if (type === "edit") {
      hoverStyles.background = "rgba(245, 158, 11, 0.2)";
    } else if (type === "delete") {
      hoverStyles.background = "rgba(239, 68, 68, 0.2)";
    } else if (type === "archive") {
      hoverStyles.background = "rgba(107, 114, 128, 0.2)";
    } else if (type === "restore") {
      hoverStyles.background = "rgba(34, 197, 94, 0.2)";
    }

    Object.assign(e.currentTarget.style, hoverStyles);
  },

  handleActionBtnMouseLeave: (e, type) => {
    const defaultStyles = {
      transform: "translateY(0)",
      boxShadow: "none",
    };

    if (type === "view") {
      defaultStyles.background = "rgba(16, 185, 129, 0.1)";
    } else if (type === "edit") {
      defaultStyles.background = "rgba(245, 158, 11, 0.1)";
    } else if (type === "delete") {
      defaultStyles.background = "rgba(239, 68, 68, 0.1)";
    } else if (type === "archive") {
      defaultStyles.background = "rgba(107, 114, 128, 0.1)";
    } else if (type === "restore") {
      defaultStyles.background = "rgba(34, 197, 94, 0.1)";
    }

    Object.assign(e.currentTarget.style, defaultStyles);
  },
});
